module.exports = __webpack_public_path__ + "img/dosamar.852990b4.png";